

































































import { Component, Vue } from 'vue-property-decorator'
import { State, Action } from 'vuex-class'

import { ProfileState } from '@/store/modules/profile/types'

const namespace: string = 'profile'

interface LoginFormFields {
  username: string
  password: string
}

@Component
export default class LoginForm extends Vue {
  authenticating: boolean = false

  form: LoginFormFields = {
    username: '',
    password: '',
  }

  @State(namespace)
  profile!: ProfileState

  @Action('login', { namespace })
  login!: (payload: { username: string, password: string }) => Promise<any>

  get canLogin () {
    return !!(this.form.username && this.form.password)
  }

  async submitHandler () {
    // set state
    this.authenticating = true

    // authenticate
    try {
      if (await this.login({ ...this.form })) {
        const to = this.$route.params.next || '/'
        this.$router.replace(to)
      }
    } finally {
      this.authenticating = false
    }
  }
}
